<template>
  <div>
    <h3 class="text-xl mb-6">Additional Attendees</h3>
    <p class="text-xs mb-6">Please select any additional attendees you would like to purchase tickets for:</p>
    <div v-if="potentialClient" class="border-bottom mb-4">
      <p><strong>Client: {{potentialClient.name}}</strong></p>
      <div class="w-full flex flex-wrap">
        <div class="place-items-center w-1/3 p-4" v-for="attendee in potentialClient.users" :key="attendee.id">
          <input type="checkbox" class="mr-2" @change="selectUser(attendee, $event)" :id="`user_${attendee.id}`" :checked="checkUserSelected(attendee)" >
          <label :for="`user_${attendee.id}`">{{ attendee.name }}  <br> {{ attendee.email }}</label>
        </div>
      </div>
    </div>
    <div v-for="(office, i) in potentialUsers" class="border-bottom mb-4" :key="i">
      <p><strong>{{ office.name }}</strong></p>
      <div class="w-full flex flex-wrap">
        <div class="place-items-center w-1/3 p-4" v-for="attendee in office.users" :key="attendee.id">
          <input type="checkbox" class="mr-2" @change="selectUser(attendee, $event)" :id="`user_${attendee.id}`" :checked="checkUserSelected(attendee)">
          <label :for="`user_${attendee.id}`">{{ attendee.name }} <br> {{ attendee.email }}</label>
        </div>
      </div>
    </div>
    <p class="text-xs mb-6">To register additional attendees, simply enter their details below.</p>
    <div v-for="(additionalUser, i) in additionalCustomUsers" :key="`custom_user_+${i}`">
      <div class="w-full flex flex-wrap">
        <div class="w-full md:w-1/2 place-items-center">
          <h4 class="w-full mt-1 mb-4 text-lg">Attendee #{{ i + potentialUsers.length + 1 }}</h4>
        </div>
        <div class="w-full md:w-1/2 text-right place-items-center">
          <button class="mb-4 px-3 py-2 bg-grey-lighter hover:text-white hover:bg-grey-darker" @click="removeUser(i)">X Delete Attendee</button>
        </div>
        <div class="w-full md:w-1/2 pr-3">
          <div class="flex-grow mr-1 mb-6">
            <label for="first_name" class="block text-xs mb-2">First Name<span class="text-primary">*</span></label>
            <input type="text" id="first_name" v-model="additionalUser.first_name" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '1'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.first_name')" v-text="errorBag.get('additional_users.' + i + '.first_name')"></small>
          </div>
          <div class="flex-grow mr-1 mb-6">
            <label for="email_address" class="block text-xs mb-2">Email Address<span class="text-primary">*</span></label>
            <input type="text" id="email_address" v-model="additionalUser.email" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '3'" @blur="checkCustomUserBooked(additionalUser, i, true)">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.email')" v-text="errorBag.get('additional_users.' + i + '.email')"></small>
          </div>
        </div>
        <div class="w-full md:w-1/2 pl-3">
          <div class="flex-grow mr-1 mb-6">
            <label for="last_name" class="block text-xs mb-2">Last Name<span class="text-primary">*</span></label>
            <input type="text" id="last_name" v-model="additionalUser.last_name" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '2'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.last_name')" v-text="errorBag.get('additional_users.' + i + '.last_name')"></small>
          </div>
          <div class="flex-grow mr-1 mb-6">
            <label for="company" class="block text-xs mb-2">Company<span class="text-primary">*</span></label>
            <input type="text" id="company" v-model="additionalUser.company" class="input w-full bg-white text-grey-darkest" :tabindex="i + 1 + '4'">
            <small class="block text-primary text-medium mt-2" v-if="errorBag.get('additional_users.' + i + '.company')" v-text="errorBag.get('additional_users.' + i + '.company')"></small>
          </div>
        </div>
      </div>
    </div>
    <button class="mb-4 px-6 py-3 bg-grey-lighter text-primary focus:outline-none"  @click="addUser()">+ Add Another Attendee</button>
  </div>
</template>
<script>
import { v2Api } from '@/http'
import { mapState } from 'vuex'

export default {
  props: ['event', 'ticket', 'order', 'errorBag'],
  data () {
    return {
      potentialUsers: [],
      potentialClient: [],
      additionalUsers: [],
      excludedUsers: [],
      additionalCustomUsers: []
    }
  },
  computed: {
    ...mapState({
      office: state => state.selectedOffice
    })
  },
  created () {
    this.getOfficeUsers()
    this.loadUsers()
    /* if (this.order.additional_users.length === 0) {
      this.addUser()
    } */
  },
  watch: {
    additionalUsers: {
      handler () {
        this.updateOrder()
      },
      deep: true
    },
    additionalCustomUsers: {
      handler () {
        this.updateOrder()
      },
      deep: true
    }
  },
  methods: {
    selectUser (user, $event) {
      let existObj = this.checkUserSelected(user)
      if (!existObj) {
        if (this.checkUserBooked(user)) {
          alert(`Warning: User ${user.email} is already an attendee of this Conference.`)
          $event.target.checked = false
          return
        }
        this.additionalUsers.push({
          user_id: user.id ? user.id : user.user_id,
          first_name: user.first_name,
          last_name: user.surname ? user.surname : user.last_name,
          email: user.email,
          company: this.office.name,
          dietary_requirements: 'None',
          allergies: 'None'
        })
        this.excludedUsers.push(user.email)
      } else {
        this.additionalUsers = this.additionalUsers.length === 1 ? [] : this.additionalUsers.filter(obj => obj.user_id !== user.id)
        this.excludedUsers = this.excludedUsers.length === 1 ? [] : this.excludedUsers.filter(obj => obj !== user.email)
      }
    },
    loadUsers () {
      let tempUsers = this.order.additional_users
      for (let user of tempUsers) {
        if (user.user_id) {
          this.selectUser(user, null)
        } else {
          this.additionalCustomUsers.push(user)
        }
      }
    },
    addUser () {
      this.additionalCustomUsers.push({
        first_name: '',
        last_name: '',
        email: '',
        company: '',
        dietary_requirements: 'None'
      })
    },
    removeUser (i) {
      this.additionalCustomUsers.splice(i, 1)
    },
    updateOrder () {
      this.order.additional_users = this.additionalUsers.concat(this.additionalCustomUsers)
    },
    getOfficeUsers () {
      v2Api
        .get(`/event-tickets/${this.ticket.ticket_id}/${this.office.id}/potential-users`)
        .then(
          response => {
            if (response.data.client) {
              this.potentialClient = response.data.client
            }
            if (response.data.offices) {
              this.potentialUsers = response.data.offices
            }
            if (response.data.booked) {
              this.excludedUsers = response.data.booked
            }
          }
        )
    },
    checkUserBooked (attendee) {
      let existed = this.excludedUsers.includes(attendee.email) || !!this.additionalUsers.find(obj => obj.email === attendee.email) ||
          !!this.additionalCustomUsers.find(obj => obj.email === attendee.email) || (!this.order.exclude_current_user && attendee.email === this.order.email)
      return existed
    },
    checkCustomUserBooked (attendee, index, alertFlag = false) {
      let addtionalCustomUsers = [ ...this.additionalCustomUsers ]
      addtionalCustomUsers.splice(index, 1)
      let existed = this.excludedUsers.includes(attendee.email) || !!this.additionalUsers.find(obj => obj.email === attendee.email) ||
        !!addtionalCustomUsers.find(obj => obj.email === attendee.email) || (!this.order.exclude_current_user && attendee.email === this.order.email)
      if (existed && alertFlag) {
        alert(`Warning: User ${attendee.email} is already an attendee of this Conference.`)
        this.additionalCustomUsers.splice(index, 1)
      }
      return existed
    },
    checkUserSelected (attendee) {
      return !!this.additionalUsers.find(obj => obj.user_id === attendee.id)
    }
  }
}
</script>
